document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.preload').forEach((element) => {
    element.classList.add('loaded');
  });
});
